import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetIsTrialActiveQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetIsTrialActiveQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, trial: { __typename?: 'SubscriptionTrial', isActive: boolean } } } | null };


export const GetIsTrialActive = /*#__PURE__*/ gql`
    query GetIsTrialActive($accountId: ID!) {
  account(accountId: $accountId) {
    id
    subscription {
      id
      trial {
        isActive
      }
    }
  }
}
    ` as unknown as DocumentNode<GetIsTrialActiveQuery, GetIsTrialActiveQueryVariables>;

          

          export const useGetIsTrialActiveQuery = (options?:QueryHookOptions<GetIsTrialActiveQuery, GetIsTrialActiveQueryVariables>) => useQuery(GetIsTrialActive, options);

          

          export type GetIsTrialActiveQueryOptions = QueryHookOptions<GetIsTrialActiveQuery, GetIsTrialActiveQueryVariables>;

          

          export const useGetIsTrialActiveLazyQuery = (options?:LazyQueryHookOptions<GetIsTrialActiveQuery, GetIsTrialActiveQueryVariables>) => useLazyQuery(GetIsTrialActive, options);

          

          export type GetIsTrialActiveQueryResult = ReturnType<typeof useGetIsTrialActiveQuery>;

          
